/**
 * ⚠ Contenido revisado. Traducción del aviso de privacidad en inglés.
 * Cada frase es una afirmación sobre el comportamiento de la aplicación:
 * no debe desviarse del código ni del texto en inglés. Ver COMPLIANCE.md.
 */
import type { privacy as privacyEn } from '../en/privacy';

export const privacy: typeof privacyEn = {
  title: 'Su privacidad',
  updated: 'Última actualización: agosto de 2026',

  summary: {
    title: 'En resumen',
    points: [
      'Lo que registra se queda en su teléfono.',
      'Families First Pediatrics no puede verlo. Nosotros tampoco.',
      'Sin cuenta, sin nombre, sin correo electrónico, sin número de teléfono.',
      'Sin publicidad, sin analíticas, sin rastreo, y no vendemos ni compartimos nada.',
    ],
  },

  sections: [
    {
      title: 'Qué guarda esta aplicación',
      body: 'Las tomas, los pañales, los pesos, las extracciones y el sueño que usted registre, además del apodo de su bebé, la fecha de nacimiento, la fecha probable de parto y sus metas de alimentación si decide agregarlas. Todo se guarda en el almacenamiento de su propio teléfono, igual que una nota en una aplicación de notas.',
    },
    {
      title: 'Qué nunca le pedimos',
      body: 'No hay que registrarse. Nunca le pedimos su nombre, el nombre legal de su bebé, su correo electrónico, su teléfono, su dirección ni los datos de su seguro. Sugerimos un apodo en lugar de un nombre real a propósito, para que aquí no tenga que existir ningún dato que la identifique.',
    },
    {
      title: 'Nadie en el consultorio está leyendo esto',
      body: 'Su registro no se envía a Families First Pediatrics y no aparece en su expediente médico. Su equipo de atención no puede abrirlo, buscarlo ni recibir avisos de él. Si quiere que vean algo, usted se lo muestra en una visita.',
    },
    {
      title: 'Conectarse con su pareja',
      body: 'Si conecta el teléfono de su pareja, los registros viajan entre los dos teléfonos a través de un servicio de enlace para que ambos estén al día. Antes de salir de su teléfono, todo se cifra con una clave creada a partir de su código de invitación, y ese código nunca sale de sus dos dispositivos. El enlace solo guarda texto cifrado que no puede leer, identificado con un código aleatorio que no está ligado a su nombre ni a su bebé.',
    },
    {
      title: 'Cuánto tiempo guarda algo el enlace',
      body: 'Los registros cifrados quedan en el enlace para que el otro teléfono los recoja, y se borran automáticamente después de 120 días sin actividad. Desconectar a su pareja detiene cualquier envío posterior. Ninguna de estas acciones borra nada de su propio teléfono.',
    },
    {
      title: 'Ningún tipo de rastreo',
      body: 'No hay publicidad, ni analíticas, ni píxeles de rastreo, ni cookies de rastreo, ni código de terceros. La aplicación está hecha de modo que no puede cargar código de ningún otro sitio, aunque alguien intentara agregarlo. No vendemos, alquilamos ni compartimos su información, porque no la tenemos.',
    },
    {
      title: 'Puede llevársela o borrarla',
      body: 'En Configuración hay un botón para guardar todo en un archivo de respaldo que usted conserva, y otro para restaurarlo. Borrar todos los datos elimina todo de este teléfono de inmediato. Eliminar la aplicación, o borrar los datos de su navegador, también lo borra, por eso vale la pena guardar el archivo de respaldo.',
    },
    {
      title: 'Información sobre menores',
      body: 'Esta aplicación es para que la use un padre, una madre o un cuidador. La información sobre su bebé es suya, se guarda en su dispositivo y nosotros nunca la recopilamos.',
    },
    {
      title: 'Esto no es consejo médico',
      body: 'La información aquí es educativa y no reemplaza la atención de su pediatra ni de su equipo de lactancia. Si le preocupa su bebé, llame al consultorio.',
    },
    {
      title: 'Preguntas',
      body: 'Llame al consultorio y pregunte por el equipo de lactancia, y le daremos una respuesta.',
    },
  ],
};
